module.exports = __webpack_public_path__ + "static/media/kdrf.ce22a537.png";